var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgBhtndSdeadline = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 31 31",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15.4886,
    cy: 15.4886,
    r: 15.4886,
    fill: "#5673EB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.456 14.8685C21.9652 14.8685 23.1744 13.7615 23.1744 12.3903C23.1744 11.019 21.9652 9.91211 20.456 9.91211C18.9468 9.91211 17.7286 11.019 17.7286 12.3903C17.7286 13.7615 18.9468 14.8685 20.456 14.8685ZM13.1828 14.8685C14.692 14.8685 15.9012 13.7615 15.9012 12.3903C15.9012 11.019 14.692 9.91211 13.1828 9.91211C11.6736 9.91211 10.4553 11.019 10.4553 12.3903C10.4553 13.7615 11.6736 14.8685 13.1828 14.8685ZM13.1828 16.5206C11.0645 16.5206 6.81873 17.4871 6.81873 19.4118V21.4769H19.5469V19.4118C19.5469 17.4871 15.3011 16.5206 13.1828 16.5206ZM20.456 16.5206C20.1924 16.5206 19.8923 16.5371 19.5741 16.5619C20.6288 17.2558 21.3652 18.1892 21.3652 19.4118V21.4769H26.8201V19.4118C26.8201 17.4871 22.5743 16.5206 20.456 16.5206Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgBhtndSdeadline, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/BHTNDSdeadline.bbb663cc.svg";
export { ForwardRef as ReactComponent };